/*
 * "Compra ya" (Buy Now) — one-click purchase.
 *
 * Clears the cart, adds ONLY the currently-selected variant + quantity, then sends
 * the user straight to the payments service's pre-payment checkout (address +
 * Shopify draft order, created before any card is charged). No amount, delivery
 * fee, or free-shipping check travels from here anymore — all of that is priced
 * server-side once the draft order exists, from the real Shopify catalog.
 *
 * After payment, pagos returns to the cart page with ?order_number=..., which
 * polls for the decision and shows a confirmation card — the theme never
 * redirects into Shopify's own /checkout, since the order already exists.
 */
(function () {
  if (window.__buyNowBound) return; // load-once guard (quick-view may re-render buy-buttons)
  window.__buyNowBound = true;

  var CHECKOUT_BASE = 'https://www.pagos.calzadodastefi.com/checkout';

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
    });
  }

  function setLoading(btn, loading) {
    var label = btn.querySelector('[data-buy-now-label]');
    if (loading) {
      btn.setAttribute('disabled', '');
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('loading');
      if (label) {
        if (!label.dataset.original) label.dataset.original = label.textContent;
        label.textContent = 'Procesando...';
      }
    } else {
      btn.removeAttribute('disabled');
      btn.removeAttribute('aria-busy');
      btn.classList.remove('loading');
      if (label && label.dataset.original) label.textContent = label.dataset.original;
    }
    var spinner = btn.querySelector('.loading-spinner, .loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !loading);
  }

  async function buyNow(btn) {
    var form = btn.closest('form');
    var variantInput = form && form.querySelector('input[name="id"]');
    if (!variantInput || !variantInput.value) {
      // Same size gate as product-form.js: reuse its inline error UI, which
      // lives in the same <product-form> custom element as this button.
      var productForm = btn.closest('product-form');
      if (productForm && typeof productForm.handleErrorMessage === 'function') {
        productForm.handleErrorMessage('Por favor seleccioná tu talla');
      }
      var variantSelects = document.querySelector(
        'variant-selects[data-section="' + btn.getAttribute('data-section-id') + '"]'
      );
      if (variantSelects) {
        variantSelects.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var firstInput = variantSelects.querySelector('input, select');
        if (firstInput) firstInput.focus();
      }
      return;
    }
    var sectionId = btn.getAttribute('data-section-id');
    var qtyInput = sectionId ? document.getElementById('Quantity-' + sectionId) : null;
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    setLoading(btn, true);

    try {
      // Buy ONLY this product: clear whatever is in the cart first.
      await postJSON('/cart/clear.js');
      await postJSON(window.routes.cart_add_url, { id: variantInput.value, quantity: quantity });

      var cart = await fetch('/cart.js').then(function (r) { return r.json(); });
      var itemsParam = cart.items
        .map(function (i) { return i.variant_id + ':' + i.quantity; })
        .join(',');

      var url =
        CHECKOUT_BASE +
        '?items=' + encodeURIComponent(itemsParam) +
        '&cart=' + encodeURIComponent(cart.token || '');

      window.location.href = url;
    } catch (err) {
      console.error('[buy-now] failed:', err);
      setLoading(btn, false);
      alert('Hubo un error al iniciar tu compra. Por favor intenta de nuevo o contáctanos al 8583-3182.');
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-buy-now]');
    if (!btn || btn.hasAttribute('disabled')) return;
    e.preventDefault();
    buyNow(btn);
  });
})();
